module.exports = {
    60101: '您已被取消提报资格',
    60102: '提报人数超出配额数量',
    60103: '提报截止时间已过',
    60104: '该资源已不存在',
    60100: '当前培训班报名尚未开始',
    60105: '当前培训班报名已结束',
    60106: '该培训班要求填写报名理由',
    60107: '本培训班报名人数已满',
    60108: '已是培训班成员或已经报名',
    60109: '当前报到结束时间已超过培训班结束时间',
    60110: '您不是培训班学员，无权查看',
    60111: '您无权限参加该培训班',
    60130: '该培训班已经满员！',
    60201: '您已不是讲师或者您的讲师身份被禁用',
    60001: '导入模板错误',
    60002: '导入数据超出限制条数',
    60003: '此业务数据存在队列中的导入任务，请稍候再试',
    60112: '培训计划不存在',
    61101: '班主任人数超出限制',
    61102: '该状态不可删除',
    61103: '找不到培训计划',
    62101: '该培训班活动签到不存在',
    62102: '该培训班活动签到还未开始',
    62103: '该培训班活动签到已结束',
    62104: '该培训班不需要签到',
    62105: '该活动学员已签到',
    63101: '该培训班学员不存在',
    63102: '员工编号不存在',
    63103: '员工编号不在您的权限范围之内',
    63104: '该用户已是正式学员',
    64101: '该状态下数据不可删除',
    64102: '启动报到后时间不能为空',
    64103: '报到开始时间不能大于或等于报到结束时间',
    64104: '培训班不存在',
    64105: '该状态下不可撤销培训班',
    64106: '只有在撤销状态下才可重新发布培训班',
    64107: '报名截止时间不能大于等于培训班开始时间',
    64108: '报名状态下，报名结束时间必须小于培训班开始时间',
    64109: '培训班时间不能为空',
    64110: '培训班开始时间不能大于等于结束时间',
    64111: '启动报名后时间内不能为空',
    64112: '报名开始时间不能大于或等于报名截止时间',
    64113: '配额数量请输入0-10000以内正整数',
    64114: '提报部门不存在或不在您的权限范围之内',
    64115: '提报人员工编号不存在',
    64116: '提报人员工编号不在您的权限范围之内',
    64117: '提报部门数据已存在',
    64118: '报到时间已过期',
    64119: '未到报到时间',
    64120: '学员已经报到',
    64121: '培训班未配置培训班证书',
    65101: '讲师级别被关联,无法移除',
    66101: '关联人员已经添加过内部讲师',
    67101: '教室已经被关联，无法删除',
    67102: '费用类别已经被关联，无法删除',
    67103: '培训地点已经被关联，无法删除',
    67104: '培训班类别已经被关联，无法删除',
    60114: '班主任员工编号不存在',
    60115: '班主任员工编号不在您的权限范围之内',
    60116: '归属部门不存在或不在您的权限范围之内',
    60117: '实施部门不存在或不在您的权限范围之内',
    60118: '培训班类别不存在',
    60119: '计划人数请输入0-10000以内正整数',
    60120: '时间格式错误',
    60121: '该提报数据不存在',
    60122: '提报部门已存在，请选择其他部门',
    60123: '提报人必填',
    60125: '提报已截止，无法编辑',
    60126: '提报已截止，无法删除',
    60601: '教室编号已存在',
    60602: '教室桌型不存在',
    60603: '教室配置不存在',
    60604: '教室编号重复导入',
    60605: '教室编号只能填数字、字母、_',
    20114: '员工编号不存在',
    41001: '员工编号不在您的权限范围之内',
    60131: '该培训班已结项',
    60995: '非法操作',
    60701: '培训班费用超出培训班预算',
    60702: '讲师费用超出培训班讲师配置费用',
    60703: '讲师配置费用不能小于讲师预算费用明细',
    62107: '该二维码已失效',
    68001: '员工编号必填',
    68002: '线下考试成绩必填',
    68003: '员工编号重复',
    68004: '员工不是班级学员',
    68005: '考试不存在或者不支持线下考试',
    68006: '活动不存在',
    68007: '分数格式不正确',
    68008: '分数超出范围',
    68009: '活动章节不存在',
    68010: '分数不合法',
    20906: '模板错误，请导入正确模板',
    201603: '文件内容为空',
    64123: '导入的提报人最多支持10个',
    68011: '在线课程业务数据异常',
    62108: '不能删除已有学员参与的签到活动',
    60136: '使用费用请输入0-100000以内最多两位小数的数值',
    60137: '成绩请输入0-1000以内最多一位小数的数值',
    63105: '协议开始时间缺失，无法导入',
    63106: '协议截止时间缺失，无法导入',
    68012: '员工不是培训班补考学员',
    60138: '请选择人员提报！',
    69001: '课程编码不存在',
    69002: '开始时间不能小于班级开始时间',
    69003: '结束时间不能大于班级结束时间',
    69004: '开始时间不能大于等于结束时间',
    69005: '单次最多导入100条数据，请分批导入',
    69006: '课程编码重复',
    60144: '活动已结束',
    60145: '活动还未开始',
    69007: '附件转换中'
};
